import { all } from 'redux-saga/effects';
import { user } from './user/sagas';
import { settings } from './settings/sagas';

export const sagas = function* rootSaga() {
  yield all([user(), settings()]);
};
